import React, { useState, useEffect } from "react";
import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Chat from "./pages/chat/Chat";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import NotFound from "./pages/NotFound";
import LayoutWrapper from "./layoutWrapper";
import Dashboard from "./pages/Dashboard";
import PrivateRoute from "./components/PrivateRoute";

const App = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [token, setToken] = useState("");

    useEffect(() => {
        const session = localStorage.getItem("session");
        if (session) {
            const { expiry } = JSON.parse(session);
            if (expiry > Date.now()) {
                setIsAuthenticated(true);
            } else {
                localStorage.removeItem("session");
            }
        }
    }, []);

    const handleLogin = () => {
        setIsAuthenticated(true);
        const expiry = Date.now() + 120 * 1000;
        localStorage.setItem("session", JSON.stringify({ expiry }));
    };

    return (
        <Router>
            <Routes>
                {/* Redirect root to login or dashboard */}
                <Route path="/" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} />} />

                {/* Authentication routes */}
                <Route path="/login" element={<Login setIsAuthenticated={handleLogin} setToken={setToken} />} />
                <Route path="/signup" element={<Signup setIsAuthenticated={handleLogin} />} />

                {/* Protected routes */}
                <Route
                    path="/chat"
                    element={
                        <LayoutWrapper>
                            <Chat />
                        </LayoutWrapper>
                    }
                />

                <Route
                    path="/dashboard"
                    element={
                        <PrivateRoute>
                            <LayoutWrapper>
                                <Dashboard />
                            </LayoutWrapper>
                        </PrivateRoute>
                    }
                />

                {/* Catch-all route */}
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Router>
    );
};

export default App;
